import React, { useState } from 'react';

const debug_level = 1; //10;
const debug_speed = 0; //10;
const debug_text = 1; //10;
let lastTimeCalled = new Date();
//static lastTime = 0;

function react_server_url(){
	const link = process.env.REACT_APP_API
	//REACT_APP_API_STRIPE=http://localhost:3030/api/stripe
	if( link === null || link === undefined)
		alert( "process.env.REACT_APP_API is NULL");
	return link;
}
function react_server_stripe_url(){
	const link = process.env.REACT_APP_API_STRIPE
	if( link === null || link === undefined)
		alert( "process.env.REACT_APP_API is NULL");
	//REACT_APP_API_STRIPE=http://localhost:3030/api/stripe
	return link;
}

const play_button = ( button_name, button_location) => {
	let name = button_name;
	//if( debug_level > 1)
		name += "-" + button_location;
	return name
}

function show_text( from){
	//if( debug_level < 1)
	//	return "";
	return "[" + from + "-Vai-1.2]"
}

function Console_log( ...args){
	//const [lastTimeCalled, setLastTimeCalled] = React.useState( 0);
	//if( debug_level < 1)
	//	return;
	let now = new Date();
	console.log( now - lastTimeCalled, ...args);
	lastTimeCalled = now;
}
function console_log( ...args){
	Console_log( ...args);
}

function Console_log_err( ...args){ //print allways
	let now = new Date();
	console.log( "*************", now - lastTimeCalled, ...args);
	lastTimeCalled = now;
}
function console_log_err( ...args){
	Console_log_err( ...args);
}

function render_page( from){
	if( debug_speed <= 0)
		return;
	console.log( "render_page from=" + from);
	return "render_page from=" + from;
}

function is_free_video( tip){
	return ( "free" === tip);
}

export default {
 //dev
  //vodafone
  //back_end_server_ip: 'http://192.168.43.44',
  //front_end_server_ip: 'http://192.168.43.44',

  //localhost
  back_end_server_ip: 'https://server.videnda.studio',
  front_end_server_ip: 'https://server.videnda.studio',
  //back_end_server_ip: 'http://localhost',
  //front_end_server_ip: 'http://localhost',

  //dev
	//dev Orange Flex5
	//back_end_server_ip: 'http://192.168.8.198',
	//front_end_server_ip: 'http://192.168.8.198',
	  //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! BUG !!!!!!!!!!!!!!!!!!!!!!!!! HARDCODARE
	//react_app_api_url: 'http://localhost:3030/api', //process.env.REACT_APP_API_URL,
	react_app_api_url: 'https://server.videnda.studio/api', //process.env.REACT_APP_API_URL,
	//react_app_api_url: 'http://192.168.43.114:3030/api', //process.env.REACT_APP_API_URL,
	//192.168.8.120
	//react_app_api_url: 'http://192.168.8.198:3030/api', //process.env.REACT_APP_API_URL,
	//react_app_api_url: 'https://aic.space:3030/api', //process.env.REACT_APP_API_URL,
	//back_end_server_ip + ":" + back_end_server_port + "/api"
	//dev Orange Dell
	//back_end_server_ip: 'http://192.168.8.134',
	//front_end_server_ip: 'http://192.168.8.134',
  //dev ports
  front_end_server_port: '80',
  back_end_server_port: '443',
  //front_end_server_port: '3000',
  //back_end_server_port: '3030',


  //production
  //back_end_server_ip: 'https://aic.space',
  //back_end_server_port: '3030',
  //front_end_server_ip: 'https://aic.space',
  //front_end_server_port: '443',

  //old-back_end_server_ip: 'https://158.69.222.102',
  //old-back_end_server_ip: 'http://127.0.0.1',

  react_server_url,
  react_server_stripe_url,

  //modal_video_player_width: 'auto',
  //modal_video_player_height: '100%',
  modal_video_player_width: '100%', //mobile
  modal_video_player_height: '100%',

  //API = process.env.REACT_APP_API_URL;
  error_template: '@Error@',
  licence_terms: "https://docs.google.com/document/d/1kZ62aE5464t_2s_kfYfhLxDFVHK2fN7-jchUBZKhcpk/edit?usp=sharing",

  video_player: "InPage", //"Torma"

  play_button, //special signs on Play buttons to identify source to debug
  Console_log, //stop console log in production
  console_log, //stop console log in production
  Console_log_err, //stop console log in production
  console_log_err, //stop console log in production
  debug_speed,
  render_page,
  is_free_video,
  show_text,
};
